const state = {
  feedbacks: [],
  headerBack: null,
  menuOpenMobile: false,
}

export default state
